const animations = [
    {
        selector: '[data-load-animation]',
        path: { dirname: 'animations', filename: 'loadAnimation' },
    },
];

const preventLoadingAnimations = [
    {
        selector: '[data-load-animation]',
        path: { dirname: 'animations', filename: 'preventLoadingAnimations' },
    },
];

export { animations, preventLoadingAnimations };
